// extracted by mini-css-extract-plugin
export default {"switchWrapper":"Switch_switchWrapper__Wd1nO","switchLabel":"Switch_switchLabel__oi1r1","boldLabel":"Switch_boldLabel__-j8Ce","discountLabel":"Switch_discountLabel__iFfIr"};